export const enums = {
	TYPES: ['POS', 'App', 'Delivery'],
	SUB_TYPES: ['Grid', 'Row'],
};
